import { FC } from "react";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './slider.css';

interface ITestimonialCarouselProps {
  slider: ISliderProps[]
}

interface ISliderProps {
  message: string,
  image: string,
  name: string,
  occupation: string,
}

export const TestimonialCarousel: FC<ITestimonialCarouselProps> = ({ slider }) => {
  console.log(slider)
  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      showIndicators={false}
      autoPlay={false}
      infiniteLoop
      className="w-full max-w-[1024px] flex items-center justify-center"
    >
      {slider.map((item, i) => (
        <div className="max-w-[840px] mx-auto px-24 text-white" key={i}>
          <div className="text-lg mb-9 lg:text-2xl leading-snug">{item.message}</div>

          <div className="max-w-[70px] lg:max-w-[100px] mx-auto mb-3">
            <img src={item.image} alt={item.name} />
          </div>

          <div className="font-bold text-[22px] text-accent">{item.name}</div>
          <div className="font-medium italic">{item.occupation}</div>
        </div>
      ))}
    </Carousel>
  );
};
